import React, { Component } from 'react'
import Cards from './Cards'
// import LightMode from './DarkModeToLightMode'
import '../Components/LightMode.scss';


export default class Toggle extends Component {


    state = {
        lightmode: false,
    }



    render() {

        const toggletheme = () => {
            this.setState({
                lightmode: !this.state.lightmode,
            })
        }



        //DESTRUCTURING THE STATE
        const { lightmode } = this.state
        console.log(lightmode);


        return (
            <>

                <div className='container' class={lightmode ? "dark" : "light"}>
                    <h1>{lightmode ? "DarkMode" : "lightMode"}</h1>
                    <button className='button' onClick={toggletheme}>
                        Switch to {lightmode ? "light mode" : "Dark Mode"}
                    </button>


                    {/* CARDS COMPONENT */}
                    <Cards />
                </div>
            </>
        )
    }
}
